import {cloneElement, ReactElement} from 'react';
import clsx from 'clsx';

interface PricingContentProps {
  children: ReactElement<{className: string}>;
  isScrollable?: boolean;
}
export function PricingContent({
  children,
  isScrollable = true,
}: PricingContentProps) {
  return cloneElement(children, {
    className: clsx(
      children.props.className,
      isScrollable && 'overflow-y-auto stable-scrollbar',
      'pricing-grid-content'
    ),
  });
}
